"use strict";

var _interopRequireDefault = require("D:/G/YT/mes-project-web/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _typeof2 = _interopRequireDefault(require("D:/G/YT/mes-project-web/node_modules/@babel/runtime/helpers/typeof.js"));
require("core-js/modules/es.array.find.js");
require("core-js/modules/es.array.push.js");
require("core-js/modules/es.iterator.constructor.js");
require("core-js/modules/es.iterator.find.js");
require("core-js/modules/es.json.parse.js");
require("core-js/modules/es.object.keys.js");
require("core-js/modules/es.object.to-string.js");
var _auth = require("@/utils/auth");
var _default = exports.default = {
  data: function data() {
    return {
      messageWSOptions: {
        message: '',
        text_content: '',
        ws: null
      }
    };
  },
  watch: {},
  computed: {
    settings: function settings() {
      return require('@/settings.js');
    },
    getWebsocket: function getWebsocket() {
      var _this$$$fuzzySearchFi;
      var key = (_this$$$fuzzySearchFi = this.$$fuzzySearchFieldName('message-websocket', Object.keys(this.settings))) === null || _this$$$fuzzySearchFi === void 0 ? void 0 : _this$$$fuzzySearchFi.find(function (k) {
        return k;
      });
      var options = this.settings[key];
      return options;
    },
    getWebsocketUrl: function getWebsocketUrl() {
      if (this.$$isEmpty(this.getWebsocket)) {
        this.$message.warning('无法获取站内信 WebSocket 地址，请在 请在 ./settings.js 文件中设置 message-websocket 设置（示例：{ disabled: false, url: ws://... }）');
      }
      switch ((0, _typeof2.default)(this.getWebsocket)) {
        case 'object':
          return this.getWebsocket.url;
        case 'string':
          return this.getWebsocket;
        default:
          return '';
      }
    }
  },
  methods: {
    createWS: function createWS() {
      var _this = this;
      var url = this.getWebsocketUrl;
      // const url = 'ws://localhost:8002/websocket/message'

      if (url) {
        var ws = new WebSocket(url + '?id=' + (0, _auth.getToken)());
        this.$store.state.massageWS = ws;
        this.messageWSOptions.ws = ws;

        // 连接成功建立的回调方法
        // ws.onopen = () => {
        //   this.text_content = this.text_content + '已经打开连接!' + '\n'
        // }
        // 接收到消息的回调方法
        ws.onmessage = function (e) {
          if (e.data !== '连接成功') {
            var h = _this.$createElement;
            try {
              var _data$unRead;
              var data = JSON.parse(e.data);
              var id = new Date().valueOf();
              _this.$refs['nav-bar'].messageNumber = (_data$unRead = data.unRead) !== null && _data$unRead !== void 0 ? _data$unRead : 0;
              if (data.content) {
                _this.$notify({
                  title: '站内信',
                  customClass: "notify-message-".concat(id),
                  message: h('div', {}, [h('div', data.content), h('div', {
                    class: {
                      asdasd: true
                    },
                    style: {
                      display: 'flex',
                      'justify-content': 'flex-end'
                    }
                  }, [h('el-button', {
                    attrs: {
                      type: 'primary',
                      size: 'mini'
                    },
                    nativeOn: {
                      click: function click() {
                        var a = {
                          query: {
                            id: data.id
                          }
                        };
                        a.path = '/record';
                        _this.$router.push(a);
                      }
                    }
                  }, '查看')])]),
                  duration: 10 * 1000,
                  position: 'bottom-right',
                  dangerouslyUseHTMLString: true
                });
                var domA = document.querySelector(".notify-message-".concat(id));
                var domB = domA.querySelector('.el-notification__group');
                var domC = domB.querySelector('.el-notification__title');
                domB.style.cssText += ';width: 100%;';
                domC.style.cssText += ';text-align: center;';
                // console.log(document.querySelector('.notify-message'))
              }
            } catch (err) {
              console.error(err);
            }
          }
        };
        // 连接发生错误的回调方法
        ws.onerror = function () {
          // this.text_content = this.text_content + 'WebSocket连接发生错误!' + '\n'
        };
        // 连接关闭的回调方法
        ws.onclose = function () {
          // this.text_content = this.text_content + '已经关闭连接!' + '\n'
        };
      } else {
        this.$message.console.warn('无法获取站内信 WebSocket 地址，请在 请在 ./settings.js 文件中设置 message-websocket 设置');
      }
    }
  },
  created: function created() {
    var _this$getWebsocket;
    if (!((_this$getWebsocket = this.getWebsocket) !== null && _this$getWebsocket !== void 0 && _this$getWebsocket.disabled)) {
      this.createWS();
    }
  }
};